import PriorityHighIcon from '@material-ui/icons/PriorityHigh'
import PriorityEdit from './PriorityEdit'

const priorities = () => ({
  icon: PriorityHighIcon,
  list: PriorityEdit,
  name: 'priorities',
})

export default priorities
